import $ from 'jquery';
import BaseModel from '../../../core/baseModel';

export default BaseModel.extend({
    defaults: {
        ajaxUrl: ''
    },

    onBeforeSend: function () {
        this.trigger('showAjaxOverlay');
    },

    onSuccess: function (data) {
        this.set(data);
    },

    onError: function () {
        throw new Error('Prevention Page: Update of prices failed');
    },

    onComplete: function () {
        this.trigger('hideAjaxOverlay');
    },

    sendForm: function (formData) {
        $.ajax({
            url: this.get('ajaxUrl'),
            type: 'POST',
            data: formData,
            beforeSend: $.proxy(this.onBeforeSend, this),
            success: $.proxy(this.onSuccess, this),
            error: $.proxy(this.onError, this),
            complete: $.proxy(this.onComplete, this)
        });
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/prevention/PreventionModel.js
 **/